<template>
  <div class="row payment">
    <div class="col">
      <slot name="main">
        <div class="row mb-3">
          <div :class="width ? width : 'col-3'"
               class="mb-3"
          >
            <label>Card number</label>
            <div v-if="primaryCard">
              <div class="row align-items-center card-row">
                <div
                  :class="{'col-5 cc-number' : (transaction && otherCards.length), 'col-6 cc-number' : !(transaction && otherCards.length)}"
                >
                  **** **** **** {{ primaryCard.card_number }}
                </div>
                <div v-if="transaction && otherCards.length"
                     class="col-4 pt-2 pl-0 cc-number radio-button-wrap"
                >
                  <label :for="'r' + primaryCard.id"
                         class="pointer"
                  >
                    <input type="radio"
                           name="card_id"
                           v-model="transaction.card_id"
                           :value="primaryCard.id"
                           :id="'r' + primaryCard.id"
                    />
                    <span class="btn-radio" />
                    Charge this card
                  </label>
                </div>
                <div
                  :class="{'col-3 cc-number' : (transaction && otherCards.length), 'col-6 cc-number' : !(transaction && otherCards.length)}"
                  class="text-right"
                >
                  <div v-if="confirmPrimaryDelete === false">
                    <button type="button"
                            class="btn btn-delete"
                            v-if="$_can('customer-cards.destroy')"
                            @click="togglePrimaryCardDelete()"
                    >
                      Delete
                    </button>
                  </div>
                  <div class="confirm-delete"
                       v-else
                  >
                    <span>Are you sure?</span>
                    <button class="btn-status btn-active"
                            @click="removeCard(primaryCard.id)"
                    >
                      Yes
                    </button>
                    <button class="btn-status toggle-delete"
                            @click="togglePrimaryCardDelete()"
                    >
                      No
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <p v-else>No credit card added</p>
            <template v-if="otherCards.length">
              <label>Additional card numbers</label>
              <div v-for="(cardElement, index) in otherCards"
                   :key="`other-cards-${index}`"
              >
                <div class="row align-items-center card-row mb-3">
                  <div :class="{'col-5 cc-number' : transaction, 'col-6 cc-number' : !transaction}">
                    **** **** **** {{ cardElement.card_number }}
                  </div>
                  <div v-if="transaction"
                       class="col-4 pt-2 pl-0 cc-number radio-button-wrap"
                  >
                    <label :for="'r' + cardElement.id" class="pointer">
                      <input type="radio" name="card_id"
                             v-model="transaction.card_id"
                             :value="cardElement.id" :id="'r' + cardElement.id"
                      />
                      <span class="btn-radio" />
                      Charge this card
                    </label>
                  </div>
                  <div v-if="$_can('customer-cards.destroy')"
                       :class="{'col-3 cc-number' : (transaction && otherCards.length), 'col-6 cc-number' : !(transaction && otherCards.length)}"
                       class="text-right"
                  >
                    <div v-if="confirmOtherDelete[index] === false || confirmOtherDelete[index] === undefined">
                      <button type="button"
                              class="btn btn-delete"
                              @click="$set(confirmOtherDelete, index, true)"
                      >
                        Delete
                      </button>
                    </div>
                    <div class="confirm-delete"
                         v-else
                    >
                      <span>Are you sure?</span>
                      <button class="btn-status btn-active"
                              @click="removeCard(cardElement.id)"
                      >
                        Yes
                      </button>
                      <button class="btn-status toggle-delete"
                              @click="$set(confirmOtherDelete, index, false)"
                      >
                        No
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <error-field :errors="errors" field="card_id" />
            <div v-if="company.payment_gateway && $_can('customer-cards.store')">
              <div class="row mt-4"
                   v-if="!showCardForm"
              >
                <div class="col-12">
                  <button type="button"
                          class="btn add-button"
                          @click="showCardForm = true"
                  >
                    <span><span class="mod-icon-add" /></span>
                    Add card
                  </button>
                </div>
              </div>
            </div>
            <div class="row mt-4"
                 v-else
            >
              <div class="col-12">
                <span class="text-danger">
                  Company merchant account not set</span>
              </div>
            </div>
          </div>
          <div :class="width ? width : ''"
               class="col-12"
               v-show="showCardForm"
          >
            <div class="row align-items-center"
                 v-if="company.payment_gateway === 'Authorize.NET' || modCustomer"
            >
              <div class="col-12 col-md-9 col-lg-9 col-xl-9 cc-form-control cc-number-field">
                <div class="row">
                  <div class="col-12 col-md-6 col-lg-6 col-xl-6">
                    <span><i class="fa fa-credit-card" /></span>
                    <input type="text"
                           v-model="modelCard.cardNumber"
                           placeholder="Card Number"
                           maxlength="16"
                    />
                  </div>
                  <div class="col-12 col-md-6 col-lg-6 col-xl-6 px-0 text-right">
                    <input type="text"
                           class="cc-form-field month-field"
                           v-model="modelCard.expMonth"
                           placeholder="MM"
                           maxlength="2"
                    />
                    <input type="text" class="cc-form-field year-field"
                           v-model="modelCard.expYear"
                           placeholder="YY"
                           maxlength="2"
                    />
                    <input type="text" class="cc-form-field cvc-field"
                           v-model="modelCard.cardCode"
                           placeholder="CVC"
                           maxlength="4"
                    />
                    <input type="text" class="cc-form-field zip-field"
                           v-model="modelCard.zip"
                           placeholder="ZIP"
                           maxlength="5"
                    />
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-3 col-lg-3 col-xl-3 text-right">
                <button type="button"
                        class="btn btn-primary ld-ext-right"
                        @click="saveCard"
                        :class="loadingButton ? 'running' : ''"
                        :disabled="buttonDisabled"
                >
                  Add Card
                  <div class="ld ld-ball ld-flip" />
                </button>
              </div>
            </div>
            <div class="row align-items-center"
                 v-else
            >
              <div class="col-9">
                <div ref="card"
                     class="form-control cc-form-control"
                />
              </div>
              <div class="col-3 text-right">
                <button type="button"
                        class="btn btn-primary ld-ext-right"
                        @click="saveCard"
                        :class="loadingButton ? 'running' : ''"
                        :disabled="buttonDisabled"
                >
                  Add Card
                  <div class="ld ld-ball ld-flip" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </slot>
      <div class="row mb-3">
        <div class="col-12">
          <div ref="cardError"
               class="text-danger"
          />
          <error-field :errors="errors" :field="payment_token" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import toastr from 'toastr';
import Errors from '../classes/Errors';
import ErrorField from './ErrorField';

export default {
  components: {
    ErrorField,
  },
  props: {
    customer: {
      type: Object,
      default: () => {},
    },
    company: {
      type: Object,
      default: () => {},
    },
    transaction: {
      type: Object,
      default: () => {},
    },
    width: {
      type: String,
      default: '',
    },
    isMod: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      payment_token: '',
      showCardForm: false,
      buttonDisabled: false,
      loadingButton: false,
      stripe: null,
      card: null,
      modelCard: {},
      errors: new Errors(),
      confirmPrimaryDelete: false,
      confirmOtherDelete: [],
    };
  },
  computed: {
    primaryCard() {
      return this.customer.customer_cards.find(c => c.is_default === 1);
    },
    otherCards() {
      return this.customer.customer_cards.filter(c => c.is_default === 0);
    },
    modCustomer() {
      return this.isMod || this.customer.make_mod_customer;
    },
  },
  watch: {
    primaryCard() {
      if (this.transaction && !this.transaction.card_id && this.primaryCard) {
        this.$set(this.transaction, 'card_id', this.primaryCard.id);
      }
    },
  },
  mounted() {
    const vm = this;
    if (this.modCustomer) {
      this.loadScript(process.env.AUTHORIZE_NET_URL, 'utf-8');
    } else {
      switch (this.company.payment_gateway) {
        case 'Authorize.NET':
        default:
          this.loadScript(process.env.AUTHORIZE_NET_URL, 'utf-8');
          break;
        case 'Stripe':
          this.loadScript('https://js.stripe.com/v3/').then(() => {
            vm.stripe = window.Stripe(vm.company.payment_gateway_key);
            const elements = vm.stripe.elements();
            if (!vm.card) {
              vm.card = elements.create('card');
            }
            vm.card.mount(vm.$refs.card);
          });
      }
    }
    if (this.transaction && this.primaryCard) {
      this.$set(this.transaction, 'card_id', this.primaryCard.id);
    }
  },
  methods: {
    async loadScript(source, charset) {
      const scripts = Array.from(document.querySelectorAll('script')).map(scr => scr.src);

      if (scripts.includes(source)) {
        return false;
      }

      const script = document.createElement('script');
      script.setAttribute('src', source);
      if (charset) {
        script.setAttribute('charset', charset);
      }

      let onLoad = null;
      let onError = null;
      try {
        return await new Promise((resolve, reject) => {
          onLoad = e => resolve(e);
          onError = e => reject(e);
          script.addEventListener('load', onLoad);
          script.addEventListener('error', onError);
          document.head.appendChild(script);
        });
      } finally {
        if (onLoad) {
          script.removeEventListener('load', onLoad);
        }
        if (onError) {
          script.removeEventListener('error', onError);
        }
      }
    },
    saveCard() {
      this.$refs.cardError.textContent = '';
      const vm = this;
      if (this.modCustomer) {
        const authData = {};
        authData.clientKey = process.env.AUTHORIZE_NET_PUBLIC_KEY;
        authData.apiLoginID = process.env.AUTHORIZE_NET_LOGIN;
        const cardData = {};
        cardData.cardNumber = this.modelCard.cardNumber;
        cardData.month = this.modelCard.expMonth;
        cardData.year = this.modelCard.expYear;
        cardData.cardCode = this.modelCard.cardCode;
        cardData.zip = this.modelCard.zip;
        const secureData = {};
        secureData.authData = authData;
        secureData.cardData = cardData;
        window.Accept.dispatchData(secureData, response => {
          if (response.messages.resultCode === 'Error') {
            vm.$refs.cardError.textContent += response.messages.message[0].text;
            vm.$forceUpdate();
          } else {
            vm.buttonDisabled = true;
            vm.loadingButton = true;
            axios
              .post(`customers/${vm.customer.id}/cards`, {
                data_descriptor: response.opaqueData.dataDescriptor,
                payment_token: response.opaqueData.dataValue,
                is_default: true,
                zip: this.modelCard.zip,
              })
              .then(() => {
                toastr.success('Successfully saved card');
                this.modelCard = {};
                if (this.transaction.card_id !== this.primaryCard.id) {
                  this.$set(this.transaction, 'card_id', this.primaryCard.id);
                }
                vm.$emit('update');
                vm.showCardForm = false;
                vm.loadingButton = false;
                vm.buttonDisabled = false;
              })
              .catch(err => {
                [vm.$refs.cardError.textContent] = err.response.data.error.exception;
                vm.loadingButton = false;
                vm.buttonDisabled = false;
              });
          }
        });
      } else {
        const authData = {};
        const cardData = {};
        const secureData = {};
        switch (vm.company.payment_gateway) {
          case 'Authorize.NET':
            authData.clientKey = this.company.payment_gateway_key.clientKey;
            authData.apiLoginID = this.company.payment_gateway_key.apiLoginID;
            cardData.cardNumber = this.modelCard.cardNumber;
            cardData.month = this.modelCard.expMonth;
            cardData.year = this.modelCard.expYear;
            cardData.cardCode = this.modelCard.cardCode;
            cardData.zip = this.modelCard.zip;
            secureData.authData = authData;
            secureData.cardData = cardData;
            window.Accept.dispatchData(secureData, response => {
              if (response.messages.resultCode === 'Error') {
                vm.$refs.cardError.textContent += response.messages.message[0].text;
                vm.$forceUpdate();
              } else {
                vm.buttonDisabled = true;
                vm.loadingButton = true;
                axios
                  .post(`customers/${vm.customer.id}/cards?company_id=${vm.company.id}`, {
                    data_descriptor: response.opaqueData.dataDescriptor,
                    payment_token: response.opaqueData.dataValue,
                    is_default: true,
                    zip: this.modelCard.zip,
                  })
                  .then(() => {
                    toastr.success('Successfully saved card');
                    this.modelCard = {};
                    vm.$emit('update');
                    vm.showCardForm = false;
                    vm.buttonDisabled = false;
                    vm.loadingButton = false;
                  })
                  .catch(err => {
                    [vm.$refs.cardError.textContent] = err.response.data.error.exception;
                    vm.loadingButton = false;
                    vm.buttonDisabled = false;
                  });
              }
            });
            break;
          case 'Stripe':
          default:
            this.stripe.createToken(this.card).then(result => {
              if (result.error) {
                vm.$refs.cardError.textContent = result.error.message;
                vm.$forceUpdate();
              } else {
                vm.buttonDisabled = true;
                vm.loadingButton = true;
                axios
                  .post(`customers/${vm.customer.id}/cards?company_id=${vm.company.id}`, {
                    payment_token: result.token.id,
                    is_default: true,
                  })
                  .then(() => {
                    toastr.success('Successfully saved card');
                    vm.$emit('update');
                    vm.card.clear();
                    if (this.transaction.card_id !== this.primaryCard.id) {
                      this.$set(this.transaction, 'card_id', this.primaryCard.id);
                    }
                    vm.showCardForm = false;
                    vm.loadingButton = false;
                    vm.buttonDisabled = false;
                  })
                  .catch(err => {
                    [vm.$refs.cardError.textContent] = err.response.data.error.exception;
                    vm.loadingButton = false;
                    vm.buttonDisabled = false;
                  });
              }
            });
        }
      }
    },
    removeCard(cardId) {
      axios
        .delete(`customers/${this.customer.id}/cards/${cardId}?company_id=${this.company.id}`)
        .then(() => {
          toastr.success('Successfully removed card');
          if (this.transaction.card_id === cardId) {
            this.$set(this.transaction, 'card_id', this.primaryCard ? this.primaryCard.id : null);
          }
          this.$emit('update');
          this.showCardForm = false;
          this.confirmPrimaryDelete = false;
          this.confirmOtherDelete = [];
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
    togglePrimaryCardDelete() {
      this.confirmPrimaryDelete = !this.confirmPrimaryDelete;
    },
    toggleOtherCardsDelete() {
      this.confirmOtherDelete = !this.confirmOtherDelete;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Payment.vue